import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=3256c99f&scoped=true"
import script from "./TableData.vue?vue&type=script&lang=js"
export * from "./TableData.vue?vue&type=script&lang=js"
import style0 from "./TableData.vue?vue&type=style&index=0&id=3256c99f&prod&scope=true&lang=css"
import style1 from "./TableData.vue?vue&type=style&index=1&id=3256c99f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256c99f",
  null
  
)

export default component.exports